module.exports = __webpack_public_path__ + "static/visual_1_3_do-984370e1175a87a30513aeedccd05da1.png";